import { useState } from 'react'
import { 
    useDispatch, 
    useSelector, 
} from 'react-redux'

import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    Input,
    Button,
    Box,
    Text,
} from '@chakra-ui/react'

import { requestPasswordResetEmail } from '../../features/auth/authSlice'

import { useFormik } from 'formik'
import * as Yup from 'yup'


export default function PasswordResetRequestView() {

    const { passwordResetRequest } = useSelector((state) => state.auth)

    const dispatch = useDispatch()

    const [isOpen, setIsOpen] = useState(true)

    const formik = useFormik({
        initialValues: {
            email: "",
        },
        validationSchema: Yup.object({
            email: Yup.string()
                .required("Email is required")
                .email("Invalid email address"),
        }),
        onSubmit: (values) => {
            dispatch(requestPasswordResetEmail({ email: values.email }))
        }
    })

    return (
        <>
            <Modal isOpen={isOpen}>
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>Reset password</ModalHeader>
                        <ModalBody>
                            {(formik.errors.email && formik.touched.email) && (<Box>{formik.errors.email}</Box>)}
                            {passwordResetRequest.isSuccess && (<Text>If an account for this email address exist, a password reset link was sent. Please check your email and follow the instructions.</Text>)}
                            {passwordResetRequest.isError && (<Text>Error changing password: {passwordResetRequest.message} Please email hello@trainlookout.com for support.</Text>)}
                            <Input
                                name='email'
                                id='email'
                                type='email'
                                placeholder='Email'
                                value={formik.values.email}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                isDisabled={(passwordResetRequest.isSuccess || passwordResetRequest.isError || passwordResetRequest.isLoading)}
                            />
                        </ModalBody>

                        <ModalFooter>
                            <Button
                                colorScheme='blue'
                                onClick={() => formik.handleSubmit()}
                                isDisabled={(passwordResetRequest.isSuccess || passwordResetRequest.isError)}
                                isLoading={passwordResetRequest.isLoading}
                            >
                                Send
                            </Button>
                            <Button 
                                onClick={() => setIsOpen(false)}
                            >
                                Close
                            </Button>
                        </ModalFooter>
                </ModalContent>
            </Modal>
        </>
    )
}